<script>
import ArrowRight from "../icons/arrow-right.svelte";
import MailSvg from "../icons/mail-svg.svelte";
import SendSvg from "../icons/send-svg.svelte";
</script>

<style>
  a {
    /** ボタン内のSVGのfill */
    fill: #FFF;
  }
</style>

<div>
  <div class="grid grid-cols-1 gap-y-4">
    <!-- お問い合わせボタン -->
    <a
      href="/contact/"
      target="_blank"
      class="w-full px-5 flex items-center justify-between rounded-lg bg-white text-primary border-primary border-solid border-2 box-border min-h-16 hover:opacity-70"
    >
      <div class="flex items-center gap-x-2">
        <MailSvg color="#4352F5" />
        <div class="font-bold text-lg">
          質問や無料相談はこちら
        </div>
      </div>
      <ArrowRight color="#4352F5" />
    </a>

    <!-- 申し込みボタン -->
    <a
      href="/entry/"
      target="_blank"
      class="w-full px-5 flex items-center justify-between rounded-lg bg-primary text-white border-primary border-solid border-2 min-h-16 hover:opacity-70"
    >
      <div class="flex items-center gap-x-2">
        <SendSvg color="#FFF" />
        <div class="font-bold text-lg">
          受講を申し込む
        </div>
      </div>
      <ArrowRight color="#FFF" />
    </a>
  </div>
</div>